(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-details"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-olanti-tab]');
    if (!trigger) return;

    const tabs = trigger.closest('[data-olanti-tabs]');
    if (!tabs) return;

    const target = trigger.dataset.olantiTab;
    const isOpen = trigger.getAttribute('aria-expanded') === 'true';

    tabs.querySelectorAll('[data-olanti-tab]').forEach((button) => {
      button.setAttribute('aria-expanded', 'false');
    });

    tabs.querySelectorAll('[data-olanti-panel]').forEach((panel) => {
      panel.hidden = true;
    });

    if (!isOpen) {
      trigger.setAttribute('aria-expanded', 'true');
      const panel = tabs.querySelector('[data-olanti-panel="' + target + '"]');
      if (panel) panel.hidden = false;
    }
  });
  } catch(e) { console.error(e); }
})();

})();
